//引入vue
import Vue from 'vue'
import Vuex from 'vuex'

//注册
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    token: '',
    showMasker: false,
    urlParams: {
      uniacid: '',
      type: '',
      share_uid: ''
    },
    userinfo: JSON.parse(localStorage.getItem('userinfo')),
    writeResult:'0',
    location:'0',
  },
  mutations: {
    SET_PAGE_TITLE(state, title){
      state.pageTitle = title
    },
    SET_SUBLINK(state, sublink){
      state.sublink = sublink
    },
    SET_DRIVER_STATUS(state, isDriver){
      state.isDriver = isDriver
    },
    SET_TOKEN(state, token){
      state.token = token
    },
    SET_MASKER_DISPLAY(state, show){
      state.showMasker = show
    },
    SET_URL_PARAMS(state, urlParams){
      state.urlParams = urlParams
    },
    SET_USER_INFO(state, userinfo){
      localStorage.setItem('userinfo', JSON.stringify(userinfo))
      state.userinfo = userinfo
    },
    SET_LOCATION:(state, data)=>{
      if(state.location == 0){
        state.location = 1
      } else {
        state.location = 0
      }
    },
    SET_RESULT:(state, data)=>{
      if(state.writeResult == 0){
        state.writeResult = 1
      } else {
        state.writeResult = 0
      }
    },
  },

  actions: {
    setPageTitle({ commit }, title){
      commit('SET_PAGE_TITLE', title)
    },
    setSublink({ commit }, sublink){
      commit('SET_SUBLINK', sublink)
    },
    setDriverStatus({ commit }, isDriver){
      commit('SET_DRIVER_STATUS', isDriver)
    },
    setToken({ commit }, token){
      commit('SET_TOKEN', token)
    },
    setMaskerDisplay({ commit }, show){
      commit('SET_MASKER_DISPLAY', show)
    },
    setParams({commit}, urlParams){
      commit('SET_URL_PARAMS', urlParams)
    },
    setUserinfo({commit}, userinfo){
      commit('SET_USER_INFO', userinfo)
    },
    setResult({commit}, writeResult){
      commit('SET_RESULT', writeResult)
    },
  },

  getters:{

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js